export default __webpack_public_path__ + "static/media/art2.23e52e88.mp4";